module.exports = __webpack_public_path__ + "static/img/mushroom2.5e17b66b.jpg";